import { render } from "./ProductUpsellPrompt.vue?vue&type=template&id=68aa0a88&scoped=true"
import script from "./ProductUpsellPrompt.vue?vue&type=script&lang=js"
export * from "./ProductUpsellPrompt.vue?vue&type=script&lang=js"

import "./ProductUpsellPrompt.vue?vue&type=style&index=0&id=68aa0a88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68aa0a88"]])

export default __exports__